var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"mediacontact-region-edit","toptitle":"Region bearbeiten","title":_vm.mediacontactRegion.name,"width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('mediacontact-region-form',{attrs:{"mediacontactRegion":_vm.mediacontactRegion,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }